import React from "react";
import SidebarProvider from "~/sidebar-provider";
import { IProps } from "./sidebar-container.types";

/**
 * Wrap components in the sidebar context provider.
 * @param props.children The components that the sidebar will appear over.
 */
const SidebarContainer = ({ children, isOpen = false }: IProps) => {
    return <SidebarProvider isOpen={isOpen}>{children}</SidebarProvider>;
};

export default SidebarContainer;
